module.exports = __webpack_public_path__ + "img/bang_diem.cf383a1e.svg";